import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { map, take } from 'rxjs/operators';
import { ResourceType } from '../../../../../core/enums';
import { Resource } from '../../../../../core/models';
import { ProcessNavigatorService } from '../../../../../core/services/process-navigator.service';

@Component({
  selector: 'kt-process-nav-resource-dialog',
  templateUrl: './process-nav-resource-dialog.component.html',
})
export class ProcessNavResourceDialogComponent implements OnInit {
  ResourceType = ResourceType;
  src = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public resource: Resource,
    private dialogRef: MatDialogRef<ProcessNavResourceDialogComponent>,
    private processNavService: ProcessNavigatorService,
  ) {}

  ngOnInit(): void {
    if (this.resource.type === ResourceType.HTML) {
      this.src = this.resource.path;
      return;
    }

    if (this.resource.type === ResourceType.PDF) {
      this.processNavService
        .getPreSigned(this.resource.path)
        .pipe(
          take(1),
          map((res) => res.data),
        )
        .subscribe((preSigned) => {
          this.src = preSigned.url;
          return;
        });
    }

    if (this.resource.path.includes('youtube')) {
      const url = this.resource.path.split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
      this.src = `https://www.youtube.com/embed/${
        url?.length > 2 ? url[2].split(/[^0-9a-z_-]/i)[0] : ''
      }`;
      return;
    }

    if (this.resource.path.includes('vimeo')) {
      const match = this.resource.path.match(
        /https?:\/\/(?:www\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^/]*)\/videos\/|album\/(\d+)\/video\/|)(\d+)(?:$|\/|\?)/,
      );
      this.src = `https://player.vimeo.com/video/${match?.length > 3 ? match[3] : ''}`;
      return;
    }

    if (this.resource.path.includes('microsoftstream')) {
      const url = this.resource.path.split(/(microsoftstream\.com\/video\/)/);
      this.src = `https://web.microsoftstream.com/embed/video/${
        url?.length > 2 ? url[2].split(/[^0-9a-z_-]/i)[0] : ''
      }`;
      return;
    }
  }

  close(event: Event): void {
    event.stopPropagation();

    this.dialogRef.close();
  }
}
